import { formatReportMoney, type IdleReport } from '@evi/shared';

/** Reads the scoped report DTO; no local accrual or payment action. */
export function IdleReportCell({ report }: { report?: IdleReport }) {
  if (!report) return <>Not recorded</>;
  if (report.idle_collection_status === 'not_applicable') return <>No idle fee</>;
  return <div>
    <strong>{formatReportMoney(report.idle_fee_cents, report.currency)}</strong>
    <div><strong>{report.billed_idle_minutes ?? 'Not recorded'} billed min</strong></div>
    <div>Grace: <strong>{report.idle_grace_minutes ?? 'Not recorded'} min</strong></div>
    <div>Cap reached: {report.idle_cap_reached == null ? 'Not recorded' : report.idle_cap_reached ? 'Yes' : 'No'}</div>
    <div>Collected: <strong>{formatReportMoney(report.idle_collected_cents, report.currency)}</strong></div>
    <div>Pending: <strong>{formatReportMoney(report.idle_pending_cents, report.currency)}</strong></div>
    {!!report.idle_waived_cents && <div>Waived or written off: <strong>{formatReportMoney(report.idle_waived_cents, report.currency)}</strong></div>}
    <div>{report.idle_collection_status.replaceAll('_', ' ')}</div>
  </div>;
}
